import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

const useWindowResize = (
  callback,
  options = {
    onlyHeight: false,
    onlyWidth: false,
    debounce: false,
    debounceTimeout: 0,
    debounceOptions: {},
  },
) => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    const handler = (event) => {
      const height = window.innerHeight;
      const width = window.innerWidth;

      if (height !== dimensions.height) {
        setDimensions({ ...dimensions, height });

        if (options.onlyHeight) {
          callback(event, dimensions);
        }
      }

      if (width !== dimensions.width) {
        setDimensions({ ...dimensions, width });

        if (options.onlyWidth) {
          callback(event, dimensions);
        }
      }

      if (!options.onlyHeight && !options.onlyWidth) {
        setDimensions({ height, width });
        callback(event, dimensions);
      }
    };

    const debouncedHandler =
      options.debounce && debounce(handler, options.debounceTimeout);

    window.addEventListener(
      'resize',
      options.debounce ? debouncedHandler : handler,
    );

    return () => {
      window.removeEventListener(
        'resize',
        options.debounce ? debouncedHandler : handler,
      );
    };
  }, [
    callback,
    dimensions,
    options.debounce,
    options.debounceOptions,
    options.debounceTimeout,
    options.onlyHeight,
    options.onlyWidth,
  ]);

  return dimensions;
};

export default useWindowResize;
